import { render, staticRenderFns } from "./Kfz2.vue?vue&type=template&id=2e4df2c3&scoped=true&lang=pug"
import script from "./Kfz2.vue?vue&type=script&lang=js"
export * from "./Kfz2.vue?vue&type=script&lang=js"
import style0 from "./Kfz2.vue?vue&type=style&index=0&id=2e4df2c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4df2c3",
  null
  
)

export default component.exports